import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import omit from 'lodash/omit';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import LocalVideoTile from '../video-components/LocalVideoTile';
import PlaceHolderTile from '../video-components/PlaceHolderTile';
import VideoTile from '../video-components/VideoTile';
import PaginatedView from './PaginatedView';
import PropTypes from 'prop-types';

StudentView.propTypes = {
  selectSpeaker: PropTypes.func,
};

export default function StudentView({ selectSpeaker }) {
  const { guestSpeakerId, tileMap, isHost, hostId, attendeeId, roster } = useSelector(
    ({ video, chime }) => ({
      guestSpeakerId: video.guestSpeakerId,
      tileMap: video.tileMap,
      isHost: chime.isHost,
      attendeeId: chime.attendeeId,
      hostId: chime.hostId,
      roster: chime.roster,
    })
  );
  const [lastSpeakers, setLastSpeakers] = useState({});
  const [paginatedRoster, setPaginatedRoster] = useState({});
  const [fullRoster, setfullRoster] = useState({});
  const hostAttendeeId = Object.keys(roster).find(
    (attendee) => roster[attendee].externalUserId === hostId
  );

  const layout = () => {
    const localLastSpeakers = {};
    const localPaginatedRoster = {};
    const localFullRoster = {};
    Object.keys(roster).forEach((id) => {
      if ([attendeeId, hostAttendeeId].includes(id)) {
        return;
      }
      localFullRoster[id] = roster[id];
      if (Object.keys(localLastSpeakers).length < 2) {
        localLastSpeakers[id] = roster[id];
      } else {
        localPaginatedRoster[id] = roster[id];
      }
    });
    setfullRoster({ ...localFullRoster });
    setLastSpeakers({ ...localLastSpeakers });
    setPaginatedRoster({ ...localPaginatedRoster });
  };

  useEffect(() => {
    layout();
    // eslint-disable-next-line
  }, [roster, hostId, attendeeId, hostAttendeeId]);

  const fillTiles = guestSpeakerId
    ? 0
    : Object.keys(lastSpeakers)
    ? 2 - Object.keys(lastSpeakers).length
    : 2;

  return (
    <Grid container justify="center" spacing={0}>
      <Grid container style={{ transition: '.3s' }} item xs={guestSpeakerId ? 6 : 4}>
        {guestSpeakerId ? (
          <>
            {guestSpeakerId !== attendeeId ? (
              <VideoTile
                videoTileId={tileMap[guestSpeakerId]}
                thisAttendeeId={guestSpeakerId}
                selectSpeaker={selectSpeaker}
                height={'66vh'}
                isSelected={true}
              />
            ) : (
              <LocalVideoTile height={'66vh'} />
            )}
          </>
        ) : (
          Object.keys(lastSpeakers).map((key, index) => {
            if (index > 2) {
              return null;
            }
            if (key === attendeeId) {
              return null;
            }
            return (
              <Grid item xs={12} key={key}>
                <VideoTile
                  videoTileId={tileMap[key]}
                  thisAttendeeId={key}
                  height={'33vh'}
                  selectSpeaker={selectSpeaker}
                />
              </Grid>
            );
          })
        )}
        {[...Array(fillTiles).keys()].map((index) => {
          return (
            <Grid item xs={12} key={index}>
              <PlaceHolderTile height={'33vh'} />
            </Grid>
          );
        })}
      </Grid>
      <Grid style={{ transition: '.3s' }} item xs={guestSpeakerId ? 6 : 8}>
        {isHost ? (
          <LocalVideoTile height={'66vh'} />
        ) : (
          <VideoTile
            thisAttendeeId={hostAttendeeId}
            videoTileId={tileMap[hostAttendeeId]}
            height={'66vh'}
          />
        )}
      </Grid>
      <Grid item container xs={12}>
        <Hidden xsDown>
          <Grid container item sm={!isHost ? 6 : 12} md={!isHost ? 9 : 12}>
            <PaginatedView
              selectSpeaker={selectSpeaker}
              pageLength={3}
              videos={guestSpeakerId ? omit(fullRoster, guestSpeakerId) : paginatedRoster}
            />
          </Grid>
        </Hidden>
        <Grid item xs={12} sm={6} md={3}>
          {!isHost && guestSpeakerId !== attendeeId && <LocalVideoTile />}
        </Grid>
      </Grid>
    </Grid>
  );
}
